<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js'
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headData: getdata().headData,
			};
		},
		props: {
			showpz: {
				type: Boolean,
				default: false
			},
			tableData: {
				type: Array,
				default: [],
			},
			headobj: {
				type: Object,
				default: {},
			},
			choosecellCode:{
				type:String,
				default:""
			},
			type: {
				type: String,
				default: ""
			},
			toseeUpdate: {
				type: Boolean,
				default: false
			}
		},
		created() {
		},
		methods: {
			inputblur(e){
				this.$emit("inputblur",e)
			},
			zcsclick(e){
				this.$emit("zcsclick",e)
			},
			forhover(table,colum,index){
				this.$emit("forhover",table,colum,index)
			},
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SmallScaleVAT/index.less');
</style>
